import CachedIcon from "@mui/icons-material/Cached";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import React from "react";
import { MenuOptionType } from "../../../../../../controls";
import { CacheConfiguration } from "../../../models/CacheConfiguration";

type Props = {
	setConfiguration: Function;
	setShowUpsertModal: Function;
	setShowDeleteModal: Function;
	onClearCache: (configuration: CacheConfiguration) => void;
};

export const useQueryCacheOptionsFunctions = ({
	setConfiguration,
	setShowUpsertModal,
	setShowDeleteModal,
	onClearCache,
}: Props) => {
	const getMenuOptions = (data: CacheConfiguration) => {
		const newOption: MenuOptionType = {
			name: "New Cached Action",
			key: "new_cached_action",
			onClick: () => {
				setConfiguration(null);
				setShowUpsertModal(true);
			},
			icon: <PlaylistAddIcon />,
		};

		if (!data) return [newOption];

		return [
			newOption,
			{
				name: "Edit Cached Action",
				key: "edit_cached_action",
				onClick: () => {
					setConfiguration(data);
					setShowUpsertModal(true);
				},
				icon: <EditIcon />,
			},
			{
				name: "Clear Cache",
				key: "clear_cache",
				onClick: () => onClearCache(data),
				icon: <CachedIcon />,
			},
			{
				name: "Delete Cached Action",
				key: "delete_cached_action",
				onClick: () => {
					setConfiguration(data);
					setShowDeleteModal(true);
				},
				icon: <DeleteIcon />,
			},
		] as MenuOptionType[];
	};

	return { getMenuOptions };
};
